var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUsermenuLanguage = function SvgIconUsermenuLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "67E66AAF-915C-48B0-B515-71D4EB35D2BF")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-menu",
    transform: "translate(-45.000000, -283.000000)",
    stroke: "#90949C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-usermenu-language",
    transform: "translate(46.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52631579,2.52631579 C3.99803303,3.52289387 5.92112725,4.12631579 8.02535801,4.12631579 C10.1055022,4.12631579 12.008633,3.53662921 13.4736842,2.56038358",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.52631579,6.31578947 C-0.488553457,8.4138486 2.59524502,9.68421053 5.50879531,9.68421053 C8.38899499,9.68421053 11.4451518,8.4427651 13.4736842,6.38751114",
    id: "Path-Copy-2",
    transform: "translate(5.473684, 8.000000) rotate(90.000000) translate(-5.473684, -8.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52631579,6.31578947 C4.56407812,8.4138486 7.6478766,9.68421053 10.5614269,9.68421053 C13.4416266,9.68421053 16.4977834,8.4427651 18.5263158,6.38751114",
    id: "Path-Copy-3",
    transform: "translate(10.526316, 8.000000) scale(-1, 1) rotate(90.000000) translate(-10.526316, -8.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52631579,11.8736842 C3.99803303,12.8702623 5.92112725,13.4736842 8.02535801,13.4736842 C10.1055022,13.4736842 12.008633,12.8839976 13.4736842,11.907752",
    id: "Path-Copy",
    transform: "translate(8.000000, 12.673684) scale(1, -1) translate(-8.000000, -12.673684) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.91472569e-13,
    y1: 8,
    x2: 16,
    y2: 8,
    id: "Path-12"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsermenuLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-usermenu-language.8a3bc840.svg";
export { ForwardRef as ReactComponent };